import AppLayout from "@components/layout/AppLayout"
import ChartAccordion from "@components/dataDisplay/chartAccordion/ChartAccordion"

async function getServerSideProps({ query }: any) {
  const endpoint = process.env.WP_ENDPOINT ?? "https://wp.fuw.ch/wp-json/fuw/v1"

  const authToken = query.auth_token ? query.auth_token.split(".") : []
  const buffer = authToken[1] ? Buffer.from(authToken[1], "base64") : ""
  const premium = buffer === "" ? false : JSON.parse(buffer.toString()).entitlements.premium

  const quotesRes = await fetch(`${endpoint}/marketdata/quotes/${query.ids}?closedUsergroup=${premium}`)
  const quotesData = await quotesRes.json()

  return { props: { quotesData } }
}

const ChartPage = ({ quotesData }: any) => {
  return (
    <AppLayout title="Chart" robots="noindex,nofollow">
      <ChartAccordion quotesData={quotesData} />
    </AppLayout>
  )
}

export { getServerSideProps }
export default ChartPage
